import React, { useState } from 'react'
import Footer from '../components/Footer'
import TopNav from '../components/TopNav'
import GmaBanner from '../components/GmaBanner'
import ImageList from '@mui/material/ImageList'
import ImageListItem from '@mui/material/ImageListItem'
import ImageListItemBar from '@mui/material/ImageListItemBar'
import IconButton from '@mui/material/IconButton'
import InfoIcon from '@mui/icons-material/Info'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useMediaQuery } from '@mui/material'

const MeetTeamPage: React.FC = () => {
    const [name, setName] = useState(false)
    const [bio, setBio] = useState(false)
    const [open, setOpen] = React.useState(false)
    const handleClose = () => setOpen(false)
    const handleClickOpen = (data: any) => {
        setBio(data.bio)
        //@ts-ignore
        setName(data.title)
        setOpen(true)
    }

    const staff = [
        {
            img: './img/team/jade.jpg',
            title: 'Jade Rogers',
            bio: ` Jade Rogers is a Historian, an adjunct professor at Metropolitan Community College and the University of Nebraska at
            Omaha and the Founder and Chief Innovation Officer of The House of Afros, Capes, & Curls. After receiving a B.A. in
            Black Studies and Elementary Education, she obtained a Master's in African American World Studies from the
            University of Iowa. She has also completed all course work towards her PhD in History at Morgan State University and has
            training as an Archivist and Oral Historian. Jade has taught on the elementary level in the District of Columbia Public
            Schools, and the University of Iowa as well. She has worked with numerous non-profit youth serving organizations
            including Boys & Girls Clubs of Omaha and Greater Washington in Maryland, Girls Inc., The Center for Holistic
            Development and most recently served as the Youth Engagement Manager at The Union for Contemporary Arts. Building
            community and service are a part of Jade's strong belief system. A Class XIX graduate from Heartland Blueprint, a
            United Way of the Midlands program to help increase minority racial/ethnic volunteer leadership, and she has served on
            many education and non-profit executive boards. With over 20 years of teaching and community engagement experience, she
            strives to raise the visibility of the tremendous contributions and accomplishments of African Americans in the Midwest.
            For The Great Plains Black History Museum, she has served as its Archivist, facilitates public programs on a variety of
            historical topics and also conducts Oral History and Genealogy workshops. And...she's a blerd at heart. Science
            fiction, fantasy, World of Warcraft, The Sims and Octavia Butler. Star Wars + Star Trek + the X-Men hold equal space in
            her heart.`
        },
        {
            img: './img/team/tamicka.jpg',
            title: 'Tamicka Bradley',
            bio: `Tamicka Bradley is an Independent Contractor in Omaha, NE. She has a Bachelor of Science in Nursing and a Masters in Integrative Health and Wellness Coaching. In her previous work endeavors, she was a senior program supervisor for the Financial Hope Collaborative at Creighton University, an Administrative Assistant of the North Division clinics with CHI, a Health Educator with Omaha Bar Bariatric Medicine, and a Community Clinical Research Liaison for the Center for Reducing Health Disparities at the College of Public Health at the University of Nebraska Medical Center.
As a retired member of the National Alliance on Mental Illness (NAMI) of Nebraska's Board of Directors, Tamicka continues to find new and innovative ways to continues to find innovative ways to promote mental health and eradicate the stigma of mental illness in the greater Omaha community.
In her current roles, she continues her life's work to help the members of the Greater Omaha community successfully live healthier lives by learning how to incorporate healthy habits into their daily lives, leading to a balanced, healthy lifestyle.
`
        },
        {
            img: './img/team/VictoriaJones.png',
            title: 'Victoria Jones',
            bio: `Victoria helps bring the House of Afros, Capes, and Curls mission and vision to life through graphics and design. Before
            joining H.O.A.C.C, Victoria did work with local nonprofits Voices for Children and Holland Children's Movement and
            Institute. She graduated with her B.S. in Communications from the University of Nebraska at Omaha in December of 2015.`
        },

        {
            img: './img/team/terra.jpg',
            title: 'Terra Taylor',
            bio: `Resident Web Developer.  More info coming soon`
        }
    ]

    const board = [
        {
            img: './img/team/wayneBrown.jpg',
            title: 'Wayne Brown, Esq.,',
            bio: `Wayne Brown is Vice President of Programs for the Urban League of Nebraska. A native of Omaha, Wayne joined the Army
            after graduating from Benson High School. After an exciting ten years in the service, he graduated magna cum laude from
            East Tennessee State University. In 2009, he graduated from Creighton Law School. He has served the Omaha community in a
            variety of non-profit capacities, from Chief Career Officer of the Avenue Scholars Foundation to Vice President of the
            Omaha Community Foundation. In his spare time Wayne enjoys biking, reading comic books and mentoring his three daughters
            in the ways of the force.`
        },
        {
            img: './img/team/juliaParker.png',
            title: 'Julia Parker',
            bio: `Julia Parker just recently began an MBA program in Business at Boston University in Boston, Massachusetts. Prior to
            leaving Omaha, she was the Executive Director of the Omaha Small Business Network (OSBN), an Omaha-based nonprofit whose
            mission is to assist historically undercapitalized entrepreneurs achieve financial inclusion. Prior to this role, Ms.
            Parker was the Director of Operations and Communications at Building Bright Futures for six years. Her connections
            within the community and lived-experience as a black female business owner were the catalyst that led her to become an
            advocate for underserved, local entrepreneurs and nonprofits; providing the tools needed to become successful and
            sustainable entities. Ms. Parker believes community-based micro-lenders, to provide access to proven pathways for
            success, thus resulting in community and economic development.`
        },
        {
            img: './img/team/jessicaEhule.png',
            title: 'Jessica Ehule MS, MSPH',
            bio: `Jessica Ehule (she/her) is a courageous public health leader with a passion for addressing health
        and racial equity through highlighting root cause issues that contribute to inequities in health
        outcomes today. She is the Birth Justice Program Manager at I Be Black Girl, the only
        reproductive justice organization in Nebraska. Jessica has served in the maternal and child
        health space for over a decade and is committed to working towards a society in which people
        are the priority. She is a life-long learner with specific interest in science, history, and sociology.
        In her leisure time she enjoys reading, exercising, exploring cuisines of the world, and hanging
        out with her black pug named Onyx.`
        },
        {
            img: './img/HOACC.png',
            title: 'Rhonda Freeman',
            bio: `Bio Coming soon`
        },
        {
            img: `./img/team/styrance.png`,
            title: 'Stephani Tyrance',
            bio: `Stephani designs and manages HIP's national capacity-building Leadership Institute for individuals working on health equity in local health departments. As a member of the capacity building team, she also facilitates workshops and provides technical assistance to public health organizations seeking to center equity in their practice. Over the last 18 years Stephani has been focused on advancing racial justice practices and supporting communities of color.
Stephani lives with her husband and seven-year-old in Kansas. They are a sports loving family that cheer on the Carolina Tar Heels, the Philadelphia Eagles and now the Jacksonville Jaguars. Stephani also enjoys spending time at the beach, hitting the trails, game nights and blerd culture, and serving her community.
`
        }
    ]
    const advisory = [
        {
            img: './img/team/denisechapman.png',
            title: 'Denise Chapman',
            bio: `Denise Chapman graduated from Creighton University with a BA in theatre. She went on to receive her MFA from the Theatre Conservatory at the Chicago College of Performing Arts at Roosevelt University. 

        After graduation she performed with Qwest Educational Programs touring elementary and middle schools in the greater Chicago land area and worked as a Solo performing artist. She returned to Omaha in 2006 and worked with Blue Barn’s Witching hour for three years as Co-Artistic director/ensemble member and at the Omaha Community Playhouse as the director of education and outreach. 
        
        She is a strong believer that art changes our lives for the better, it gives a voice to those who feel like they are not being heard, and expresses a vision of hope to all those who are touched by it. 
        
        Currently she is the Artistic Director of  Theatre, The Union for Contemporary Art and an adjunct professor at Creighton University. `
        },
        {
            img: './img/team/KelleyCoble.jpg',
            title: 'Kelley Coble',
            bio: `Kelley Coble is all about creating learning spaces where students can thrive, dream big, and conquer their futures. She’s a champion of personalized education, social-emotional well-being, and making sure every scholar is ready to take on college, careers, and life. Known for turning big ideas into action, Kelley loves bringing people together, mentoring future leaders, and finding creative solutions to help students shine. When she’s not building communities, you’ll find her curled up with a good book, sipping coffee, or geeking out over board games, beauty finds, and classic 80’s music and movies.`
        },
        {
            img: './img/team/KrystalFox.jpg',
            title: 'Krystal Fox',
            bio: `Krystal Fox is basically a native Nebraskan who believes in the potential of our city and state to be welcoming and inclusive places for all people. She earned her Bachelors in Political Science with a minor in African American History. This focus is woven throughout all the work she does. Krystal started her career after volunteering with a political campaign where she learned the skills needed for people and process management. 
            This experience set her on a path of focusing on people management and customer experience that she has loved as she continues to develop. Krystal's time in both the operations and the financial world have  allowed her to focus on creating a smooth and efficient client experience that met fast-paced demands. She is able to build and strengthen skills in effective project management and communication in order to meet the needs of my client, my team, and my company.
            
            Krystal spends a lot of her personal time volunteering with organizations that focus on improving opportunities for civic engagement and voter engagement. She loves working in a community that is focused on creating positive social change and is always looking to learn new skills to be an impactful change agent. Currently, she serves as the Co-Director for Social Policy with the League of Women Voters and the Vice President of DEIB for Junior League of Omaha. Krystal has also served as Tour Manager for the last 3 years to the Face-to-Face with Black History Tour. Krystal is also in the process of founding the Youth Civic Engagement Academy focused on ensuring Youth voices are a part of the civic landscape.
            `
        },
        {
            img: './img/team/LeslieSmith.jpeg',
            title: 'Leslie Smith',
            bio: `Leslie Smith serves as the Executive Director for the Omaha Municipal Land Bank, where she aims to lead the organization’s efforts to transform problem properties into vibrant opportunities in partnership with the community. Before joining the OMLB team, she worked for Truist Bank’s Strategic Growth team, where she worked to develop strategies that drive Mortgage inclusive lending activities to support generational wealth-building and work towards closing the racial wealth gap throughout the bank’s digital footprint. During her tenure at the Blight Authority of Memphis (BAM), she addressed multidimensional and systemic challenges, which inhibited urban renewal within the Memphis community throughout the global pandemic. Through leveraging this cross-sector leadership and collaborative partnerships within the neighborhoods, she was able to champion and finance its efforts to drive change at the local level. With a passion for improving all residents’ quality of life regardless of the zip code, Smith looks to bring her national network, cross-sector expertise, and collective experience to drive momentum within addressing vacant and abandoned properties at the root.`
        },
        { img: './img/HOACC.png', bio: `Bio coming soon`, title: 'Olajide Cooper' }
    ]

    const matches = useMediaQuery('(max-width:800px)')

    /**
     * Call this function to redirect the user to the homepage.
     */

    return (
        <>
            <TopNav />
            <div className="container-fluid w-100 h-auto mt-5 p-0 d-flex justify-content-center">
                <img src="./img/HOACC.png" className="img-fluid p-0 mt-5 top-image" alt="House of Afros, Capes and Curls logo" />
            </div>

            <section className="" style={{ padding: '0', margin: 0 }}>
                <div className="container-fluid" style={{ padding: 0, margin: 0 }}>
                    <div className="row" style={{ padding: 0, margin: 0 }}>
                        <div className="col" style={{ padding: 0, margin: 0 }}>
                            <div className="text-center" style={{ backgroundColor: '#908068', color: 'black' }}>
                                <h1 className="text-uppercase py-1 subheading">Meet the Team</h1>
                            </div>
                        </div>
                    </div>
                </div>
                <Dialog open={open} onClose={handleClose} aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description" id="bio-info">
                    <DialogTitle id="alert-dialog-title">{name}</DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">{bio}</DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose}>Close</Button>
                    </DialogActions>
                </Dialog>
                <h2 className="text-center">Staff</h2>
                <div className="container-fluid w-100 h-auto p-0 d-flex justify-content-center">
                    <ImageList sx={{ width: '100%', height: matches ? '100%' : 500 }} cols={matches ? 1 : 4}>
                        {staff.map((item) => (
                            <ImageListItem key={item.img}>
                                <img
                                    srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                    src={`${item.img}?w=300&fit=crop&auto=format`}
                                    alt={item.title}
                                    loading="lazy"
                                />
                                <ImageListItemBar
                                    title={item.title}
                                    // subtitle={item.author}
                                    actionIcon={
                                        <IconButton
                                            sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                            aria-label={`info about ${item.title}`}
                                            onClick={() => handleClickOpen(item)}
                                        >
                                            <InfoIcon />
                                        </IconButton>
                                    }
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                </div>
                <h2 className="text-center">Board</h2>
                <div className="container-fluid w-100 h-auto p-0 d-flex justify-content-center">
                    <ImageList sx={{ width: '100%', height: matches ? '100%' : 375 }} cols={matches ? 1 : 5}>
                        {board.map((item) => (
                            <ImageListItem key={item.img}>
                                <img
                                    srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                    src={`${item.img}?w=248&fit=crop&auto=format`}
                                    alt={item.title}
                                    loading="lazy"
                                />
                                <ImageListItemBar
                                    title={item.title}
                                    // subtitle={item.author}
                                    actionIcon={
                                        <IconButton
                                            sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                            aria-label={`info about ${item.title}`}
                                            onClick={() => handleClickOpen(item)}
                                        >
                                            <InfoIcon />
                                        </IconButton>
                                    }
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                </div>
                <h2 className="text-center">Advisory Council</h2>
                <div className="container-fluid w-100 h-auto p-0 d-flex justify-content-center">
                    <ImageList sx={{ width: '100%', height: matches ? '100%' : 375 }} cols={matches ? 1 : 5}>
                        {advisory.map((item) => (
                            <ImageListItem key={item.img}>
                                <img
                                    srcSet={`${item.img}?w=248&fit=crop&auto=format&dpr=2 2x`}
                                    src={`${item.img}?w=200&fit=crop&auto=format`}
                                    style={{ height: matches ? '100%' : '150px' }}
                                    alt={item.title}
                                    loading="lazy"
                                />
                                <ImageListItemBar
                                    title={item.title}
                                    actionIcon={
                                        <IconButton
                                            sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                                            aria-label={`info about ${item.title}`}
                                            onClick={() => handleClickOpen(item)}
                                        >
                                            <InfoIcon />
                                        </IconButton>
                                    }
                                />
                            </ImageListItem>
                        ))}
                    </ImageList>
                </div>
            </section>
            <div className="row mt-5">
                <div className="col">
                    <GmaBanner />
                </div>
            </div>

            <Footer />
        </>
    )
}

export default MeetTeamPage
